(() => {
  let listenersAttached = false;

  function initDiscountScript() {
    const appliedDiscountsContainer = document.getElementById('applied-discounts');
    const applyBtn = document.getElementById('apply-discount-btn');
    const discountInput = document.getElementById('discount-input');

    if (!appliedDiscountsContainer || !applyBtn || !discountInput) return;

    const strings = window.cartDiscountStrings || {};
    const MSG_NO_CODE = strings.errorNoCode || "Please enter a discount code.";
    const MSG_ALREADY_APPLIED = strings.errorAlreadyApplied || "That discount code is already applied.";
    const MSG_INVALID = strings.errorInvalid || "Discount code is invalid or not applicable.";

    function clearMessages() {
      const errDiv = document.getElementById('discount-error-message');
      if (errDiv) {
        errDiv.style.display = 'none';
        errDiv.textContent = '';
      }
    }

    function showError(msg) {
      const errDiv = document.getElementById('discount-error-message');
      if (errDiv) {
        errDiv.style.display = 'block';
        errDiv.textContent = msg;
      }
    }

    function getCurrentDiscounts() {
      const pills = document.querySelectorAll('#applied-discounts .discount-pill');
      return Array.from(pills).map((pill) => pill.getAttribute('data-code').toUpperCase());
    }

    function triggerCartUpdate() {
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      const fakeEvt = { currentTarget: {} };

      if (cartDrawerItems && typeof cartDrawerItems.updateQuantity === 'function') {
        const qtyInput =
          document.getElementById('Drawer-quantity-1') ||
          document.getElementById('Quantity-1');
        if (qtyInput) {
          const currentQty = parseInt(qtyInput.value, 10) || 1;
          cartDrawerItems.updateQuantity(1, currentQty, fakeEvt, null, null);
          return;
        } else {
          cartDrawerItems.onCartUpdate();
          return;
        }
      }

      const cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        const qtyInput =
          document.getElementById('Quantity-1') ||
          document.getElementById('Drawer-quantity-1');
        if (qtyInput) {
          const currentQty = parseInt(qtyInput.value, 10) || 1;
          cartItems.updateQuantity(1, currentQty, fakeEvt, null, null);
          return;
        } else {
          cartItems.onCartUpdate();
          return;
        }
      }
    }

(async () => {
  const BXGY_CODE = 'GRATIS ZERO WASTE ZEEP';
  const BXGY_VARIANT = 52132158406995;

  async function applyDiscounts(discountCodes = []) {

    const settings = window.cartDiscountSettings || {};
    const drawerMsg = document.getElementById('discount-drawer-message');

    const showMessage = (msg) => {
      if (!drawerMsg) return;
      const duration = (settings.bxgy_message_duration || 10) * 1000;
      const fontWeight = settings.bxgy_font_weight || 'bold';
      const color = settings.bxgy_color || '#27ae60';
      drawerMsg.textContent = msg;
      drawerMsg.style.display = 'block';
      drawerMsg.style.opacity = '1';
      drawerMsg.style.transition = 'opacity 0.5s ease';
      drawerMsg.style.fontWeight = fontWeight;
      drawerMsg.style.color = color;
      setTimeout(() => {
        drawerMsg.style.opacity = '0';
        setTimeout(() => { drawerMsg.style.display = 'none'; }, 500);
      }, duration);
    };

    // --- 1️⃣ Add BXGY gift if needed ---
    if (discountCodes.some(c => c.toUpperCase() === BXGY_CODE.toUpperCase())) {
      let giftAdded = false;

      try {
        const cartRes1 = await fetch('/cart.js');
        const cartData1 = await cartRes1.json();
        const exists = cartData1.items.some(item => item.id === BXGY_VARIANT);

        if (!exists) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: BXGY_VARIANT,
              quantity: 1,
              properties: { "_auto_added": "true" }
            })
          });

          // Poll until gift exists (max 20 attempts × 200ms = 4s)
          for (let i = 0; i < 20; i++) {
            const check = await fetch('/cart.js');
            const checkData = await check.json();
            if (checkData.items.some(item => item.id === BXGY_VARIANT)) {
              giftAdded = true;
              break;
            }
            await new Promise(r => setTimeout(r, 200));
          }
        } else {
          giftAdded = true;
        }

        if (giftAdded) {
          triggerCartUpdate();
          showMessage(settings.bxgy_gift_message || '🎁 Gratis Zero Waste Zeep toegevoegd!');
        }
      } catch (e) {
        console.error('BXGY gift add failed:', e);
      }
    }

    // --- 2️⃣ Apply discount codes (tutorial logic) ---
    const strings = window.cartDiscountStrings || {};
    const MSG_NO_CODE = strings.errorNoCode || "Please enter a discount code.";
    const MSG_ALREADY_APPLIED = strings.errorAlreadyApplied || "That discount code is already applied.";
    const MSG_INVALID = strings.errorInvalid || "Discount code is invalid or not applicable.";

    const errDiv = document.getElementById('discount-error-message');
    if (errDiv) { errDiv.style.display = 'none'; errDiv.textContent = ''; }

    const pills = document.querySelectorAll('#applied-discounts .discount-pill');
    const currentCodes = Array.from(pills)
      .map(p => p.getAttribute('data-code').toUpperCase())
      .filter(c => c !== BXGY_CODE.toUpperCase());

    for (const code of discountCodes) {
      const newCode = code.trim().toUpperCase();
      if (!newCode) {
        if (errDiv) { errDiv.style.display = 'block'; errDiv.textContent = MSG_NO_CODE; }
        continue;
      }
      if (currentCodes.includes(newCode)) {
        if (errDiv) { errDiv.style.display = 'block'; errDiv.textContent = MSG_ALREADY_APPLIED; }
        continue;
      }

      try {
        const url = `/discount/${encodeURIComponent([...currentCodes, newCode].join(','))}?redirect=/cart`;
        await fetch(url, { method: 'GET', mode: 'no-cors', credentials: 'include' });
      } catch (_) {}
    }

    // --- 3️⃣ Refresh cart & validate BXGY ---
    const validateDiscount = async () => {
      const cartRes = await fetch('/cart.js', { credentials: 'include' });
      const cartData = await cartRes.json();
      const validSet = new Set();
      (cartData.cart_level_discount_applications || []).forEach(d => validSet.add(d.title.toUpperCase()));
      cartData.items.forEach(item => {
        (item.line_level_discount_allocations || []).forEach(a => validSet.add(a.discount_application.title.toUpperCase()));
      });
      return validSet.has(BXGY_CODE.toUpperCase());
    };

    const success = await validateDiscount();
    if (!success && discountCodes.some(c => c.toUpperCase() === BXGY_CODE.toUpperCase())) {
      // Retry BXGY once after 700ms
      await new Promise(r => setTimeout(r, 700));
      try { await fetch(`/discount/${encodeURIComponent(BXGY_CODE)}?redirect=/cart`, { method: 'GET', mode:'no-cors', credentials:'include' }); } catch(_) {}
    }

    triggerCartUpdate();
  }

  // --- Attach listener once ---
  if (!window._listenersAttachedForDiscounts) {
    document.addEventListener('click', async (e) => {
      if (e.target && e.target.id === 'apply-discount-btn') {
        const discountInputValue = document.getElementById('discount-input')?.value || '';
        await applyDiscounts([discountInputValue]);
      }
    });
    window._listenersAttachedForDiscounts = true;
  }
})();

    if (!listenersAttached) {
      document.addEventListener('click', async (e) => {
        if (e.target && e.target.id === 'apply-discount-btn') {
          clearMessages();
          const existingCodes = getCurrentDiscounts();
          let newCode = (document.getElementById('discount-input')?.value || '').trim().toUpperCase();
          if (!newCode) {
            showError(MSG_NO_CODE);
            return;
          }
          if (existingCodes.includes(newCode)) {
            showError(MSG_ALREADY_APPLIED);
            return;
          }
          const combinedCodes = [...existingCodes, newCode];
          const result = await applyDiscounts(combinedCodes);
          if (result.invalidCodes.map(c => c.toUpperCase()).includes(newCode)) {
            showError(MSG_INVALID);
          }
        }

        if (e.target && e.target.closest('.remove-discount')) {
          clearMessages();
          const pill = e.target.closest('.discount-pill');
          if (!pill) return;
          const codeToRemove = pill.getAttribute('data-code');
          if (!codeToRemove) return;
          const existingCodes = getCurrentDiscounts();
          const newDiscountList = existingCodes.filter(c => c !== codeToRemove.toUpperCase());
          await applyDiscounts(newDiscountList);
        }
      });
      listenersAttached = true;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initDiscountScript();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      initDiscountScript();
    });
  }
})();
